import { CHANNEL_OPTIONS } from "components/EboStoreV4/data";
import { arrType, datatypes, inputTypes } from "./globalData";
import SummarizeIcon from '@mui/icons-material/Summarize';
import StoreIcon from '@mui/icons-material/Store';
import { Roles } from "./authData";

export const store_budget_tracker_data = {
	report: {
		name: "Report",
		key: "report",
		display: true,
	},
	store: {
		name: "Store Budget",
		key: "store_budget",
		display: true,
	},
};

export const WORK_TYPE_OPTIONS = [
	{
		name: "NEW",
		key: "NEW",
	},
	{
		name: "RENOVATION",
		key: "RENOVATION",
	},
];

export const CHANNEL_LIST = [
    {
        name: "EBO",
        key: "EBO",
        brand_code: "EBO",
    },
    {
        name: "LFS",
        key: "LFS",
        brand_code: "LFS",
    },
    {
        name: "MBO",
        key: "MBO",
        brand_code: "MBO",
    },
];

export const storeBudgetTrackerFields= [
    {
        name: "Project Id",
        key: "project_id",
        input_type: inputTypes.AUTO_GENERATE.key,
        constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
    },
    {
            name: "Channel",
            key: "channel",
            input_type: inputTypes.SELECT.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
            option_data: {
                type: arrType,
                list: CHANNEL_LIST,
            },
        },
        {
            name: "Work Type",
            key: "work_type",
            input_type: inputTypes.SELECT.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 0,
            group: "",
            option_data: {
                type: arrType,
                list: WORK_TYPE_OPTIONS,
            },
        },
        {
            name: "Store Name",
            key: "store_name",
            input_type: inputTypes.SELECT.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 0,
            group: "",
            option_data: {
                type: arrType,
                list: CHANNEL_OPTIONS,
            },
        },
        {
            name: "Store Code",
            key: "store_code",
            input_type: inputTypes.AUTO_GENERATE.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "Project",
            key: "project",
            input_type: inputTypes.ENTER.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
            placeholder: "Enter Project",
        },
        {
            name: "City",
            key: "city",
            input_type: inputTypes.AUTO_GENERATE.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "State",
            key: "state",
            input_type: inputTypes.AUTO_GENERATE.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "Store Opening Date",
            key: "store_opening_date",
            input_type: inputTypes.ENTER.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.DATE.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "Carpet Area",
            key: "carpet_area",
            input_type: inputTypes.ENTER.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.NUMBER.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "STD Per Sq feet",
            key: "std_per_sq_feet",
            input_type: inputTypes.ENTER.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.NUMBER.key,
            sort_no: 1,
            group: "",
        },
        {
            name: "Total Budget",
            key: "total_budget",
            input_type: inputTypes.AUTO_GENERATE.key,
            constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
            data: {},
            data_type: datatypes.STRING.key,
            sort_no: 1,
            group: "",
        },
];

export const storeBudgetDashboardServices = {
	masters: {
		name: "Store Budget",
		key: "store_budget",
		display: true,
		icon: <StoreIcon />,
		types: {
			report: {
				name: "Report",
				key: "report",
				display: true,
				icon: <SummarizeIcon />,
			},
			store_budget: {
				name: "Store Budgets",
				key: "store_budgets",
				display: true,
				icon: <StoreIcon />,
			},
			create_store_budget: {
				name: "Create Store Budget",
				key: "create_store_budget",
				display: false,
				// icon: <FormatListBulletedIcon />,
			},
		},
	},
};

export const SbtRoleAccess = (user) =>{
    let roles = "VIEWER"

    const rolesArray = Roles.map((role) => role.key);

    if (user?.role?.["ADMIN"]) {
      roles = "ADMIN";
    }
    else{
        Object.keys(user?.role).forEach((role) => {
            if ( rolesArray.includes(role)){
                roles = role
            }
        })
    }
  return {roles};
}

export const storeBudgetTrackerReport= [
    {
        name: "Store Name",
        key: "store_name",
        input_type: inputTypes.SELECT.key,
        constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        option_data: {
            type: arrType,
            list: CHANNEL_LIST,
        },
    },
    {
        name: "Start Date",
        key: "start_date",
        input_type: inputTypes.ENTER.key,
        constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.DATE.key,
        sort_no: 1,
        group: "",
    },
    {
        name: "End Date",
        key: "end_date",
        input_type: inputTypes.ENTER.key,
        constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.DATE.key,
        sort_no: 1,
        group: "",
    },
]
